import { createUrlFromParams } from 'helpers/url';
import { getQueryParams } from 'helpers/queryParams';
import { isLoginMode } from 'helpers/signIn/loginMode';
import { publicEnvConfig } from 'helpers/env';

export const getDealershipUrl = (dealershipId) => `${publicEnvConfig.RELATIVE_BASE_URL}/dealerships/${dealershipId}`;
export const getCheckoutUrl = () => `${publicEnvConfig.RELATIVE_BASE_URL}/checkouts/edit`;
export const getSelfServeCreditsUrl = () => '/self_serve_credits';

export const getBosssiteDealershipUrl = (dealershipId, absolute = false) =>
	`${absolute ? publicEnvConfig.BASE_URL : publicEnvConfig.RELATIVE_BASE_URL}/bosssite/dealerships/${dealershipId}`;

export const getBosssiteUserUrl = (userId, absolute = false) =>
	`${absolute ? publicEnvConfig.BASE_URL : publicEnvConfig.RELATIVE_BASE_URL}/bosssite/users/${userId}`;

export const getBosssiteDealershipsUrl = () => `${publicEnvConfig.RELATIVE_BASE_URL}/bosssite/dealerships`;

export const getBosssiteVehicleUrl = (vehicleId, absolute = false) =>
	`${absolute ? publicEnvConfig.BASE_URL : publicEnvConfig.RELATIVE_BASE_URL}/bosssite/vehicles/${vehicleId}`;

export const getSellersManageOfferPage = (vehicleId) =>
	`${publicEnvConfig.RELATIVE_BASE_URL}/inventory/vehicles/${vehicleId}/offers`;

export const getVdpURL = (vehicleId) => {
	return `/vehicle_detail/${vehicleId}`;
};

export const getRailsSettingsUrl = () => `${publicEnvConfig.RELATIVE_BASE_URL}/users/settings`;

export const getSignInUrl = (referer) => {
	if (!referer) return '/sign_in';

	const modeFromReferer = getQueryParams(referer).mode;
	const modeParam = isLoginMode(modeFromReferer) ? `&mode=${encodeURIComponent(modeFromReferer)}` : '';

	return `/sign_in?referer=${encodeURIComponent(referer)}${modeParam}`;
};

export const getSearchUrlForMakeAndModal = ({ make, model, utms = {} }) =>
	`/search?${createUrlFromParams({ keywords: `${make} ${model}`, ...utms })}`;

export const getSearchUrlWithParams = (params = {}) => {
	return `/search?${createUrlFromParams(params)}`;
};

export const getAFCWelcomePageUrl = (referer) => {
	return `/afc/welcome${referer ? `?referer=${encodeURIComponent(referer)}` : ''}`;
};

export const OPENLANE_SUPPORT_EMAIL = 'us.support@openlane.com';
export const EXTERNAL_LANDING_URL = 'https://www.openlane.com';
export const CORPORATE_SITE_URL = ' https://corporate.openlane.com';
